import React from "react";
import ReactImageMagnify from "react-image-magnify";
import { presets } from "config/images";

const ImageZoom = ({
  alt,
  smallImageFile,
  largeImageFile,
  smallFormat = "productMainImage",
  smallWidth = "600",
  smallHeight = "600",
}) => {
  return (
    <ReactImageMagnify
      {...{
        isActivatedOnTouch: true,
        lensStyle: { backgroundColor: "rgba(0,0,0,.6)" },
        enlargedImagePosition: "over",
        smallImage: {
          alt: alt,
          isFluidWidth: true,
          src:
            smallImageFile +
            `?format=${smallFormat}&width=${smallWidth}&height=${smallHeight}&size=1&extension=jpeg`,
        },
        largeImage: {
          src: largeImageFile + "?format=full",
          width: presets.full.width,
          height: presets.full.height,
        },
      }}
    />
  );
};
export default ImageZoom;
